export default class DynamicFields {

	constructor(name) {

		window[name] = this.data()
	}

	data() {
		return {
			loading: true,
			saving: false,
			groupname: null,
			fields: {},
			text: '',


			init(endpoint, groupname) {
				var vm = this;
				var xhttp = new XMLHttpRequest();
				vm.groupname = groupname;
				vm.fields = []
				vm.loading = true

				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.fields = JSON.parse(this.responseText)[groupname];
						vm.loading = false
					}

					if( vm.fields == undefined){
						vm.fields = [];
					}
				}
				
				xhttp.open('get', endpoint , true);
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				// setTimeout(function() {
					xhttp.send();
				// }, 500)
			},

			save(endpoint){
				
				var vm = this;
				vm.saving = true;
				var xhttp = new XMLHttpRequest();
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				
				var Fields = vm.fields.map(function(item){
					item.group = vm.groupname
					return item;
				})
				
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						// setTimeout(()=> {
						vm.fields = JSON.parse(this.responseText)[vm.groupname];
						vm.saving = false
					// },500)
					}
				}
				
				xhttp.open('PATCH', endpoint , true);
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send(JSON.stringify( {'term': 1 , 'fields': Fields } ) );
				
				
			},

			destroy(index){

				var vm = this;
				vm.loading = true;
				var xhttp = new XMLHttpRequest();



				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {

						// vm.fields.splice(index,1)

						vm.fields = JSON.parse(this.responseText);
						vm.loading = false
					}
				}
				
				xhttp.open('DELETE', '/api/dynamic-field/' + vm.fields[index].id , true);
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send(JSON.stringify( {'term': 1 , 'fields': vm.fields } ) );
				
			}
			

		}
	}
}